import { render, staticRenderFns } from "./digmy.vue?vue&type=template&id=681b7dfe&scoped=true"
import script from "./digmy.vue?vue&type=script&lang=js"
export * from "./digmy.vue?vue&type=script&lang=js"
import style0 from "./digmy.vue?vue&type=style&index=0&id=681b7dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b7dfe",
  null
  
)

export default component.exports